<template>
    <div class="wrap">
        <!-- 顶部导航栏-->
        <my-header title="组织关系批量接转" isGoback="no" @goback="goback($event)"></my-header>
        <!--头部-->
        <div class="hd"></div>
        <div class="zhuanchu">
            <span class="tag">转出</span>
            <div class="cell_wrap">

                <!--                <van-cell center title="转出组织" :value="selectLeagueName" is-link  @click="selectOutOrg('01TZB,00DJZTZB')" />-->

                <van-cell title="转出组织">
                    <template #right-icon>
                        <input type="text" class="telInput"
                               @click="goselectLeague1()" v-if="ruleForm.outLeagueName!=''"
                               :value="ruleForm.outLeagueName">
                        <input type="text" placeholder="请选择" class="telInput" @click="goselectLeague1()" v-else>
                    </template>
                </van-cell>


                <div class="cell">
                    <span>转出团员</span>
                    <van-dropdown-menu>
                        <van-dropdown-item :title="usertitle" ref="usersItem" @close="onCloseUser()">
                            <van-checkbox-group v-model="selectedUsers" ref="checkboxGroup" @change="onChangeUser()">
                                <van-cell-group>
                                    <van-list v-for="(item, index) in userList" :key="item.userId">

                                        <van-cell clickable :title="item.name" v-if="item.userId in conflictUsers && conflictUsers[item.userId] == 0">

                                            <template #right-icon>
                                                <van-checkbox :name="item" ref="checkboxes" disabled label-position="left">
                                                正在办理业务，不可选
                                                </van-checkbox>
                                            </template>
                                        </van-cell>
                                        <van-cell clickable :title="item.name" @click="toggle(index)" v-else>

                                            <template #right-icon>
                                                <van-checkbox  :name="item" ref="checkboxes"/>
                                            </template>
                                        </van-cell>
                                    </van-list>
                                </van-cell-group>

                                <div class="select_btn">
                                    <!--<van-button color="#e32322" @click="checkAll(checked = !checked)">
                                        全选
                                    </van-button>-->
                                    <span @click="onConfirm()">取消</span>
                                    <span @click="onConfirm()">确认</span>
<!--                                    <van-button color="#1989fa" @click="onConfirm()">-->
<!--                                        取消-->
<!--                                    </van-button>-->
<!--                                    <van-button color="#e32322" @click="onConfirm()">-->
<!--                                        确认-->
<!--                                    </van-button>-->
                                </div>
                            </van-checkbox-group>

                        </van-dropdown-item>
                    </van-dropdown-menu>
                </div>
            </div>

        </div>
        <div class="zhuanru">
            <span class="tag">转入</span>
            <div class="cell_wrap">
                <van-cell center title="转入组织">
                    <template #right-icon>
                        <input type="text" class="telInput"
                               @click="goselectLeague2()" v-if="ruleForm.inLeagueName!=''"
                               :value="ruleForm.inLeagueName">
                        <input type="text" placeholder="请选择" class="telInput" @click="goselectLeague2()" v-else>
                    </template>
                </van-cell>

                <div class="cell">
                    <span>转出原因</span>
                    <vant-select
                            :list="reasonOption"
                            optionName="name"
                            type="objectArr"
                            @chooseFn="chooseIdentityFn">
                    </vant-select>
                </div>

            </div>

        </div>

        <div class="btn_wrap">
            <van-button color="#e32322" @click="send()">提交</van-button>
        </div>

        <!--选择转出组织-->
        <select-org-one class="telInput" leagueTypeId="01TZB,00DJZTZB" :show="selectedOutLeague"
                        @close="outLeagueclose($event)"
                        @chooseOrg="chooseOutOrg($event)"></select-org-one>
        <!--选择转入组织-->
        <select-org-one class="telInput" leagueTypeId="01TZB" :show="selectedInLeague"
                        @close="inLeagueclose($event)"
                        @chooseOrg="chooseInOrg($event)"></select-org-one>


    </div>

</template>

<script>
    import {mapState} from 'vuex'
    import MyHeader from '../../../components/MyHeader'
    // import MySelect from '../../components/MySelect'
    import vantSelect from '../../../components/vantSelect'
    import selectOrgOne from '../../../components/selectOrgOne'
    import cons from '../../../cons.vue'
    import Toast from "vant/es/toast";

    export default {
        name: "piliangTransfer",
        components: {MyHeader, vantSelect, selectOrgOne},
        data() {
            return {
                show: false,
                list: [],
                loading: false,
                finished: false,
                showSelect: false,
                selectLeagueName: "",
                reasonOption: [
                    {id: 2, name: "升学"},
                    {id: 3, name: "工作"},
                    {id: 1, name: "搬迁"},
                    {id: 0, name: "其他"}

                ],

                userList: [],
                checked: false,
                usertitle: "请选择",

                ruleForm: {
                    outLeagueId: '',
                    outLeagueName: '',
                    inLeagueName: '',
                    inLeagueId: '',
                    outReson: '',
                    users: '',
                    userIds: '',
                    usersList: '',
                },

                selectedOutLeague: false,
                selectedInLeague: false,

                selectedUsers: [],//本次选中的接转人员

                queryleagueId: "",
                conflictUsers: {},


            }
        },
        created() {
            if ('selectedLeagueInfo' in this.curParams) {
                this.activeName = this.curParams['selectedLeagueInfo'].activeName
            }
            if ('processBaseData' in this.curParams) {
                this.activeName = this.curParams['processBaseData'].activeName
            }

        },
        computed: {
            ...mapState({
                curParams: state => state.commonparams, // 从详情页返回
                curLeague: state => state.league,
                curUser: state => state.user,
            }),
        },
        destroyed() {

        },
        methods: {
            chooseIdentityFn(e) {
                this.ruleForm.outReson = e.id
                console.log(e)

            },

            //关闭弹框后调用
            outLeagueclose() {
                this.selectedOutLeague = false
            },
            //选中组织后调用
            chooseOutOrg(outLeagueInfo) {
                this.selectedOutLeague = false
                this.ruleForm.outLeagueId = outLeagueInfo.leagueId
                this.ruleForm.outLeagueName = outLeagueInfo.leagueName
                //选中转出组织后，搜索该组织下的团员
                this.getMemberStatistic(outLeagueInfo.leagueId)
            },
            //点击选择按钮打开弹框
            goselectLeague1() {
                this.selectedOutLeague = true
            },

            //关闭弹框后调用
            inLeagueclose() {
                this.selectedInLeague = false
            },
            //选中组织后调用
            chooseInOrg(outLeagueInfo) {
                this.selectedInLeague = false
                this.ruleForm.inLeagueId = outLeagueInfo.leagueId
                this.ruleForm.inLeagueName = outLeagueInfo.leagueName
            },
            //点击选择按钮打开弹框
            goselectLeague2() {
                this.selectedInLeague = true
            },

            getMemberStatistic(v) {
                let paramDate = new FormData()
                paramDate.append('statisticalLeagueId', v)
                this.$root.PF('/tuanyuan/leagueMemberStatistic', paramDate, {baseURL: cons.u}).then((response) => {
                    self.loading = false
                    if (response.status == 200) {
                        if (response.data.retCode === 1000) {
                            //alert('ok,submit success!')

                            this.adminName = response.data.results.adminName
                            this.adminMobile = response.data.results.adminMobile
                            var memberTotal = response.data.results.leagueMemberStatistic.memberTotal;
                            if (memberTotal <= 200) {
                                this.queryleagueId = v
                                this.getLeagueMember(v)
                            } else {
                                this.queryleagueId = v

                            }
                        }
                    }
                });

            },
            getLeagueMember(v) {
                let param = new FormData()
                param.append('queryLeagueId', v)

                this.loading = true
                this.PF('/public/get501', param, {baseURL: cons.u}).then((response) => {
                    this.loading = false
                    if (response.status == 200) {
                        if (response.data.retCode === 1000) {
                            this.outLeagueUserOptions = response.data.results.userList
                            this.userList = response.data.results.userList
                            this.conflictUsers = response.data.results.conflictUsers

                        } else {
                            Toast(response.data.retMsg);
                        }
                    } else {
                        Toast('获取数据发生异常.' + response.status);
                    }
                }).catch((error) => {
                    this.loading = false
                    console.log(error)

                });
            },


            toggle(index,disabled) {

                //不能选择超过30个人
                if (!this.$refs.checkboxes[index].checked) {
                    if (this.selectedUsers.length >= 30) {
                        Toast("最多转出人数不能超过30人");
                        this.$refs.checkboxes[index].toggle(false)
                        return
                    }
                }
                this.$refs.checkboxes[index].toggle();
            },
            //选择每一个人员时出发
            onChangeUser() {
                if (this.selectedUsers.length > 0) {
                    let users = ""
                    for (let i in this.selectedUsers) {
                        if (i == this.selectedUsers.length - 1) {
                            users += this.selectedUsers[i].name
                        } else {
                            users += this.selectedUsers[i].name + "、"
                        }
                    }
                    if (users.length >= 10) {
                        this.usertitle = users.slice(0, 10) + "..."
                    } else {
                        this.usertitle = users
                    }
                }else{
                    this.usertitle="请选择"
                }
            },
            checkAll() {
                this.$refs.checkboxGroup.toggleAll(this.checked);
            },
            //选择人员后触发
            onConfirm() {
                this.$refs.usersItem.toggle();
                this.onCloseUser()
            },
            //选择的员框被关闭时触发
            onCloseUser() {
                if (this.selectedUsers.length > 0) {

                    this.ruleForm.users = ""
                    this.ruleForm.userIds = ""
                    this.ruleForm.usersList = ""

                    let users = ""
                    let userIds = ""
                    let usersList = []
                    for (let i in this.selectedUsers) {
                        if (i == this.selectedUsers.length - 1) {
                            users += this.selectedUsers[i].name
                            userIds += this.selectedUsers[i].userId
                        } else {
                            users += this.selectedUsers[i].name + "、"
                            userIds += this.selectedUsers[i].userId + ","
                        }
                        let obj = {}
                        obj['userId'] = this.selectedUsers[i].userId
                        obj['name'] = this.selectedUsers[i].name
                        usersList.push(obj)
                    }
                    this.ruleForm.users = users
                    this.ruleForm.userIds = userIds
                    this.ruleForm.usersList = JSON.stringify(usersList)
                }
            },

            selectOutOrg(leagueTypeId) {
                var param = {
                    leagueTypeId: leagueTypeId,
                    selectedOutLeagueInfo: this.selectedOutLeagueInfo,
                    selectedInLeagueInfo: this.selectedInLeagueInfo,
                    selectedUserInfo: this.selectedUserInfo,
                    selectedTransferReason: this.selectedTransferReason,
                }

                this.$store.commit('SET_PARAMS', {'selectOrg': param})
                this.jump('/selectOrg')
            },

            send() {
                if (this.ruleForm.outLeagueId.length <= 0) {
                    Toast('请选择转出团支部');
                    return;
                }
                if (this.ruleForm.inLeagueId.length <= 0) {
                    Toast('请选择转入团支部');
                    return;
                }
                if (this.selectedUsers.length <= 0) {
                    Toast('转出人员不能为空，请选择');
                    return;
                }
                if (this.selectedUsers.length > 30) {
                    Toast('最多转出人数不能超过30人');
                    return;
                }
                if (this.ruleForm.outReson.length <= 0) {
                    Toast('请选择办理转接的原因');
                    return;
                }
                if (this.ruleForm.outLeagueId == this.ruleForm.inLeagueId) {
                    Toast('转入与转出不可以是同一个团组织');
                    return
                }
                this.doSend()
            },
            doSend() {
                let param = new FormData()
                for (let k in this.ruleForm) {
                    param.append(k, this.ruleForm[k])
                }

                this.loading = true
                this.PF('/businesstw/transfer/handlbatch', param, {baseURL: cons.u}).then((response) => {
                    this.loading = false
                    console.log("response.status:" + response.status)
                    if (response.status == 200) {
                        if (response.data.retCode === 1000) {
                            Toast(response.data.retMsg);
                            this.goback();
                        } else {
                            Toast(response.data.retMsg);
                        }
                    } else {
                        Toast('获取数据发生异常.' + response.status);
                    }
                })
                    .catch((error) => {
                        console.log(error)
                    });
            },

            goback(data) {//返回上一页
                let param = {
                    activeName: 'zero'
                }
                this.$store.commit('SET_PARAMS', {'manage/managetransferprocessview': param})
                this.$router.back(-1)
            },

            select() {
                this.show = true
            },
            chooseOrg() {

            },


        }
    }
</script>

<style scoped>
    * {
        box-sizing: border-box;
    }

    .wrap {
        background-color: #eeedf0;
        height: 100%;
        width: 100%;

    }

    .hd {
        padding-top: 50px;

    }

    .zhuanchu, .zhuanru {
        margin: 10px 0;
        background-color: white;
        display: flex;
        align-items: flex-start;
    }

    .tag {
        background-color: #e32322;
        color: white;
        border-radius: 5px;
        padding: 0 5px;
        font-size: 13px;
        margin: 10px 20px;

    }

    .zhuanru .tag {
        background-color: #ffa800;
    }

    .cell_wrap {
        flex: 1;
    }

    .cell {
        display: flex;
        flex: 1;
        align-items: center;
        border-bottom: 1px solid #e5e5e5;
        height: 40px;
        justify-content: space-between;
        padding-right: 10px;

    }

    .cell span {
        flex: 0 0 100px;
        font-size: 15px;
        color: #656565;
    }

    .wrap .van-cell {
        font-size: 15px;
        color: #656565;
        padding: 10px 16px 10px 0;
    }

    .select_btn {
        display: flex;
        width: 80%;
        margin: 0px auto;
        padding: 20px;
        justify-content: space-between;
        text-align: center;
    }
    .select_btn span{
        height: 40px;
        line-height: 40px;
        border-radius: 5px;
        color: white;
        background-color: #66b1ff;
    }
    .select_btn span:nth-child(2) {
        background-color: #e32322;
    }


    .btn_wrap {
        width: 80%;
        height: 40px;
        margin: 40px auto;
    }

    .telInput {
        border: none;
        text-align: right;
        outline: none;
    }

    .wrap /deep/ .van-button--normal {
        color: white;
        width: 100px;
    }

    .wrap /deep/ .van-dropdown-menu__bar {
        height: 100%;
        box-shadow: none;
    }

    .wrap /deep/ .van-dropdown-item__content {
        max-height: 200px;
        overflow-y: scroll;
    }

    .btn_wrap /deep/ .van-button--normal {
        width: 100%;
        border-radius: 5px;
    }

    .van-popup {
        width: 95%;
        height: 80%;
        border-radius: 5px;
        background-color: #eeedf0;
    }

    .selectOrg_wrap {
        width: 100%;
    }

    .search_wrap {
        padding: 60px 20px 0 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;

    }

    .search_wrap .van-search {
        background-color: transparent;
        flex: 0 0 80%;
    }

    .selectOrg_wrap .van-list {
        width: 95%;
        margin: 10px auto;
        border-radius: 5px;
    }

    /deep/ .selectOrg_wrap .van-button--normal {
        height: 30px;
        width: 60px;
        border-radius: 5px;
    }

    /deep/ .selectOrg_wrap .van-list .van-cell {
        border-bottom: 1px solid #ebedf0;
        padding: 10px 5px;
        align-items: center;

    }

    /deep/ .selectOrg_wrap .van-list .van-cell__title {
        padding-left: 10px;
        line-height: 30px;
        text-align: left;
        padding-right: 10px;
    }

    /deep/ .van-checkbox-group .van-cell__title, .van-cell__value{
        padding-left: 10px;
    }



</style>
